import { ClientType } from "../../config-api/index.js";
// MWM constants
export const CUSTOMER_ADDRESS_KEY = "geoLocationName";
export const CUSTOMER_POSTAL_CODE_KEY = "postalCode";
export const CUSTOMER_POSTAL_REGION_KEY = "postal";
// RE constants
export const CUSTOMER_AREA_KEY = "area";
export const CUSTOMER_CONTACT_PERSON_KEY = "contactPerson";
export const CUSTOMER_TAX_NUMBER_KEY = "taxNumber";
export const CUSTOMER_CATEGORY_ID_KEY = "categoryId";
export const CUSTOMER_CONTACT_EMAIL_KEY = "contactEmail";
export const CUSTOMER_CONTACT_MOBILE_KEY = "contactMobile";
export const CUSTOMER_THROW_DELEGATE_KEY = "throwDelegate";
export const CUSTOMER_CONTACT_PEOPLE_KEY = "contactPeople";
export const CUSTOMER_PAYMENT_STATUS_KEY = "paymentStatus";
// Primary stations have priority 1. Backup/redundancy stations have priority 2 or 3.
export const PRIMARY_POINT_PRIORITY = 1;
export var TypeEnum;
(function (TypeEnum) {
    TypeEnum["Business"] = "business";
    TypeEnum["BusinessParent"] = "business_parent";
    TypeEnum["Household"] = "household";
    TypeEnum["HouseholdParent"] = "household_parent";
})(TypeEnum || (TypeEnum = {}));
export const allCustomerTypes = [
    TypeEnum.Business,
    TypeEnum.BusinessParent,
    TypeEnum.Household,
    TypeEnum.HouseholdParent,
];
const baseCustomerTypes = [
    TypeEnum.Business,
    TypeEnum.Household,
];
export const supportedCustomerTypesByClientType = {
    [ClientType.RealEstate]: allCustomerTypes,
    [ClientType.Mwm]: baseCustomerTypes,
};
//# sourceMappingURL=constants.js.map